const REQUIRED_ENV_VARS = [
  'REACT_APP_API_URL',
  'REACT_APP_STORAGE_DOMAIN',
  'REACT_APP_DOMAIN',
  'REACT_APP_STRIPE_API_KEY',
  'REACT_APP_GOOGLE_CLIENT_ID',
  'REACT_APP_FACEBOOK_APP_ID',
] as const;

type RequiredEnvVar = typeof REQUIRED_ENV_VARS[number];

interface EnvValidationResult {
  valid: boolean;
  missing: RequiredEnvVar[];
}

export function validateEnv(): EnvValidationResult {
  const missing = REQUIRED_ENV_VARS.filter(
    (key) => !process.env[key]
  ) as RequiredEnvVar[];

  return { valid: missing.length === 0, missing };
}

export function assertEnv(): void {
  const { valid, missing } = validateEnv();
  if (!valid) {
    const list = missing.map((k) => `  - ${k}`).join('\n');
    throw new Error(
      `Missing required environment variables. Add them to your .env file or CI/CD secrets:\n\n${list}\n\nSee README.md for descriptions and example values.`
    );
  }
}
